import { api } from './api';

const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v != null && v !== '') q.append(k, String(v));
  });
  const s = q.toString();
  return s ? `?${s}` : '';
};

export const cashBanksApi = {
  listAccounts: (params = {}) =>
    api.get(`/cash-banks/accounts${qs(params)}`),

  previewClosing: (body) =>
    api.post('/cash-banks/closings/preview', body),

  createClosing: (body) =>
    api.post('/cash-banks/closings', body),

  listClosings: (params = {}) =>
    api.get(`/cash-banks/closings${qs(params)}`),

  dailyReport: (params = {}) =>
    api.get(`/cash-banks/daily-report${qs(params)}`),
};
